import React, { useEffect } from "react";
import { initExtractedDiseasesAction } from "../../../state/usecase/disease_knowledge/actions";
import { useCareRecipientList } from "../../hooks/care_recipient/useCareRecipientList";
import { useAppDispatch } from "../../../state/store";
import { initAssessmentInfoAction } from "../../../state/usecase/assessment/info/actions";
import { initAssessmentScheduleAction } from "../../../state/usecase/assessment/schedule/actions";
import { resetSelectedCareRecipientAction, selectCareRecipientAction } from "../../../state/usecase/care_recipient/actions";
import { useSendLocationToGtag } from "../../hooks/common/useSendLocationToGtag";
import { CareRecipientListProvider } from "../../provider/CareRecipientListProvider";
import { CareRecipientListTopArea } from "./components/CareRecipientListTopArea";
import { CareRecipientListPaginate } from "./components/CareRecipientListPaginate";
import { CareRecipientList } from "./components/CareRecipientList";
import { Navigate } from "react-router-dom";
import { Paths } from "../../../Paths";

export function CareRecipientListPage() {
    const dispatch = useAppDispatch();

    const { careRecipients } = useCareRecipientList();

    useSendLocationToGtag("利用者一覧");

    useEffect(() => {
        dispatch(initAssessmentInfoAction());
        dispatch(initAssessmentScheduleAction());
        dispatch(initExtractedDiseasesAction());
    });

    useEffect(() => {
        dispatch(resetSelectedCareRecipientAction());
    }, [dispatch]);

    useEffect(() => {
        if (careRecipients.length === 1) {
            const target = careRecipients[0];
            dispatch(selectCareRecipientAction({ id: target.id, name: target.name, houseId: target.houseId, customerCode: target.customerCode, branchCode: target.branchCode }));
        }
    }, [careRecipients, dispatch]);

    return careRecipients.length === 1 ? (
        <Navigate to={`${Paths.dashBoard}/${careRecipients[0].id.value}`} replace />
    ) : (
        <CareRecipientListProvider>
            <div className={"care_recipient_list_page"}>
                <div className={"container"}>
                    <h1 className={"title"}>利用者一覧</h1>
                    <CareRecipientListTopArea />
                    <CareRecipientList />
                    <CareRecipientListPaginate />
                </div>
            </div>
        </CareRecipientListProvider>
    );
}
